import type { GyymApiClient } from '@gyym/sdk'
import React from 'react'
import { SWRConfig, SWRConfiguration } from 'swr'

import { GyymAuthUserProvider } from './GyymAuthUserProvider'
import { GyymClientProvider } from './GyymClientProvider'

export interface GyymProviderProps {
  client: GyymApiClient
  swr?: SWRConfiguration
  children: React.ReactNode
}

export const GyymProvider = ({ client, swr, children }: GyymProviderProps) => (
  <SWRConfig value={swr}>
    <GyymClientProvider client={client}>
      <GyymAuthUserProvider>{children}</GyymAuthUserProvider>
    </GyymClientProvider>
  </SWRConfig>
)
